import { useState } from 'react';
import TourSite from './TourSite';

export default function TourDetails(props) {

  const [chosenSite, setChosenSite] = useState();
  const [showingPackList, setShowPackList] = useState(false);
  const [packListContent, setPackListContent] = useState('');

  const sorter = (sortBy) => (a, b) => a[sortBy].toLowerCase() > b[sortBy].toLowerCase() ? 1 : -1;

  let categoryNames = {
    '291815015046972850': 'Heiß',
    '291815120424666548': 'Kalt',
    '291815240398538165': 'Snack',
    '291815298430928310': 'Frisch',
    '291815398993561015': 'Pfand',
    '291815481914951096': 'Eis',
    '291815547329316281': 'Sonstiges',
  };

  const getTradeUnits = (missingAmount, tradeUnitContent, tradeUnitWastage) => {
    let tradeUnits = 0;
    if (tradeUnitContent <= 1) return missingAmount;
    let tradeUnitThreshold = tradeUnitContent * (100.0 - tradeUnitWastage) / 100.0;
    if (missingAmount < tradeUnitThreshold) return tradeUnits;
    tradeUnits = Math.floor(missingAmount / tradeUnitContent);
    if (missingAmount - tradeUnits * tradeUnitContent > tradeUnitThreshold) tradeUnits++;
    return tradeUnits;
  }

  const showPackList = () => {
    setShowPackList(true);
    let tourProductData = {};
    Object.entries(props.tourData.sites).forEach(([skey, site]) => {
      Object.entries(site.machines).forEach(([key, machine]) => {
        if (machine.productData === null) return;
        Object.entries(machine.productData).forEach(([pkey, product]) => {
          if (tourProductData[product['category_id']] == undefined) {
            tourProductData[product['category_id']] = [];
          }
          if (tourProductData[product['category_id']][product['base_material_id']] == undefined) {
            tourProductData[product['category_id']][product['base_material_id']] = product;
          }
          tourProductData[product['category_id']][product['base_material_id']]['rounded_amount'] = 0;
        });
      });
    });
    Object.entries(props.tourData.sites).forEach(([skey, site]) => {
      Object.entries(site.machines).forEach(([key, machine]) => {
        if (machine.productData === null) return;
        Object.entries(machine.productData).forEach(([pkey, product]) => {
          if (product['current_amount'] <= product['trade_unit_fill_threshold']) {
            tourProductData[product['category_id']][product['base_material_id']]['rounded_amount'] += getTradeUnits(product['max_amount'] - product['current_amount'], product['trade_unit_content'], product['trade_unit_wastage']) * product['trade_unit_content'];
          }
        });
      });
    });
    let newContent = [];
    setPackListContent('');
    Object.entries(tourProductData).forEach(([productCategoryId, productCategoryData]) => {

      let productEntries = Object.values(productCategoryData);
      productEntries.sort(sorter('name'));
      let categoryItems = [];
      productEntries.forEach((product) => {
        if (product.rounded_amount == undefined || product.rounded_amount <= 0) return;
        categoryItems.push(<tr><td>{product.name}</td><td style={{ textAlign: 'right' }}>{Math.round(product.rounded_amount / product.trade_unit_content)}</td></tr>);
      });
      if (categoryItems.length > 0) {
        newContent.push(<tr className='blue'><td colSpan="2">{categoryNames[productCategoryId] ?? 'Unbekannt'}</td></tr>);
        newContent = newContent.concat(categoryItems);
      }
    });
    setPackListContent(newContent);
  }

  const hidePackList = () => {
    setShowPackList(false);
  }

  const chooseSite = (siteId) => {
    setChosenSite(siteId);
  }

  const clearSite = () => {
    setChosenSite(null);
  }

  let content;
  if (showingPackList) {
    content =
      <div>
        <h3 className="ui inverted block header"><i className="chevron left icon" onClick={hidePackList}></i>Packliste Tour {props.tourData.tour.num}</h3>
        <table className="ui unstackable celled very compact single line table packlist">
          <thead>
            <tr><th colSpan="2">
              Produkte
            </th>
            </tr></thead>
          <tbody>
            {packListContent}
          </tbody>
        </table>
      </div>
  }
  else {
    if (chosenSite == null) {
      const items = Object.values(props.tourData.sites).map(site => <div className="event" key={site.id} onClick={() => chooseSite(site)}>
        <div className={(site.allMachinesDone ? "green" : "") + " label"} data-text={site.machine_count}></div>
        <div className="content">
          <div className="summary">
            <a className="header">{site.name}</a>
            <div className="date">
              {new Date(site.arrival_time).toLocaleTimeString()}
            </div>
          </div>
          <div className="meta">
            <a className="like">
              {site.address}, {site.zip} {site.city}
            </a>
          </div>
        </div>
      </div>);
      content = <div>
        <h3 className="ui inverted block header"><i className="chevron left icon" onClick={props.clearTour}></i>Tour {props.tourData.tour.num}</h3>
        <a onClick={e => showPackList()}><i className='clipboard list icon'></i> Packliste</a><br />
        <div className='ui divider'></div>
        <div className="ui divided feed">{items}</div>
      </div>
    }
    else {
      content = <TourSite site={chosenSite} machineTypes={props.tourData.machineTypes} clearSite={clearSite} setServiceQueue={props.setServiceQueue} userOptions={props.userOptions} />;
    }
  }

  return (
    <div>

      {content}
    </div>
  );
}